<template>
    <div class="beian">
      <el-divider content-position="center">
        <el-link href="https://beian.miit.gov.cn/" target="_blank">京ICP备19025263号</el-link>
      </el-divider>
    </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
/* 如何正确固定 footer 到底部*/
.beian{
  background-color: white;
  height: 66px;
  position: flex;
  bottom: 0;
  width: 100vw;
  flex: 0 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Footer/Footer.vue